/*
 * @Author: 王枫叶
 * @Date: 2020-09-28 16:52:13
 * @LastEditors: 王枫叶
 * @LastEditTime: 2020-12-19 14:39:39
 */
import {IMAGE_CND_LINK, VID_CND_LINK} from "@/config";

const baseConfig = {
    baseServerUrl: process.env.VUE_APP_BASE_API, //请求地址
    playVideoUrl: "/vid/m3u8", //视频播放
    imgUrl: IMAGE_CND_LINK, //图片预览
    downLoadUrl: VID_CND_LINK + "/", //视频下载
    videoURL: process.env.VUE_APP_BASE_API + "/api/web/admin",
    sourceURL: "/vid/m3u8"
};

baseConfig.baseServerUrl = process.env.VUE_APP_BASE_API + "/api/web/admin";
baseConfig.baseServerUrl2 = process.env.VUE_APP_BASE_API + "/api";

export default baseConfig;
